import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsIceSkateNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.905 1.093a1.958 1.958 0 012.448 1.325l.113.387a4.708 4.708 0 003.152 3.185l1.52.462A2.625 2.625 0 0115 8.963v.078c0 .734-.403 1.373-1 1.709h.042c1.081 0 1.958.877 1.958 1.958 0 .713-.578 1.292-1.292 1.292H1.292A1.292 1.292 0 010 12.708v-.667c0-.713.578-1.291 1.292-1.291h.771l.152-.161A2.623 2.623 0 011 8.375v-.53c0-.299.04-.596.12-.883l1.057-3.79a1.958 1.958 0 011.318-1.348zm-2.36 9.906l-.942 1H1.292a.042.042 0 00-.042.042v.667c0 .023.019.042.042.042h13.416a.042.042 0 00.042-.042.708.708 0 00-.708-.708h-1.645l-.941-1h-.806l-.105-.001-.942 1H5.397l-.941-1H3.546zm2.322-.324l.07.075h2.82a7.306 7.306 0 01-.846-.284l-.104-.042a2.373 2.373 0 00-.892-.174H6.29a.042.042 0 00-.03.013l-.305.326a1.28 1.28 0 01-.088.086zm1.286-7.907a.708.708 0 00-.886-.48l-2.41.732a.708.708 0 00-.476.488l-1.056 3.79c-.05.178-.075.362-.075.547v.53c0 .76.616 1.375 1.375 1.375H5.01a.042.042 0 00.03-.013l.306-.327c.244-.262.586-.41.944-.41h.625c.467 0 .93.09 1.362.265l.103.042a6.042 6.042 0 002.27.443h2.392a.708.708 0 00.708-.709v-.078c0-.605-.396-1.14-.975-1.315l-1.52-.462a5.953 5.953 0 01-.415-.142L9.442 8.442l-.884-.884L9.676 6.44a5.959 5.959 0 01-.692-.54L7.942 6.942l-.884-.884L8.15 4.966a5.953 5.953 0 01-.468-.765l-1.24 1.24-.884-.883 1.639-1.64z"
        fill=""
      />
    </svg>
  )
);
SvgSportsIceSkateNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsIceSkateNormalXsmall;
